// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"2e019d66","142":"7cc39dc9","536":"fea883ec","816":"5e9181d9"}[chunkId] + ".chunk.js";
};